import script from "./splash-screen.vue?vue&type=script&setup=true&lang=js"
export * from "./splash-screen.vue?vue&type=script&setup=true&lang=js"

import "./splash-screen.vue?vue&type=style&index=0&id=9f046660&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f046660"]])

export default __exports__